class AjaxRequest {
    constructor(options = {}) {
        this.elementToAddLoading = null;
        this.requestType = 'POST';
        this.successCallback = () => {};
        this.errorCallback = () => {};

        Object.assign(this, options);
    }

    _setLoading(active) {
        const el = this.elementToAddLoading;
        if (!el) return;

        const nodes = typeof el === 'string'
            ? document.querySelectorAll(el)
            : el instanceof Element
                ? [el]
                : Array.from(el); // NodeList, jQuery object, Array

        nodes.forEach(node => node.classList.toggle('is-loading', active));
    }

    async makeCall(url, params = {}, options = {}) {
        this._setLoading(true);

        try {
            const response = await fetch(url, {
                method: this.requestType.toUpperCase(),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(params).toString(),
                ...options,
            });

            const json = await response.json();

            if (response.ok) {
                this.successCallback(json);
            } else {
                this.errorCallback({ responseJSON: json });
            }
        } catch (err) {
            this.errorCallback({ responseJSON: { message: err.message } });
        } finally {
            this._setLoading(false);
        }
    }
}

export default AjaxRequest;